import Fuse from 'fuse.js'
import {MinimalGameDetail} from '@app/api/games/get-games-list'
import {LanguageCodes} from '@app/i18n/settings'

export type SearchGame = Omit<MinimalGameDetail, 'playCount'> & {
  playCount: string
}

const fuseSingletonObj: Partial<Record<LanguageCodes, Fuse<SearchGame>>> = {}

type Props = {
  text: string
  allGames: SearchGame[]
  lang: LanguageCodes
}

const options = {
  threshold: 0.3,
  minMatchCharLength: 1,
  keys: ['code', 'name', 'nameEn'],
  shouldSort: true,
}

export function filterResults({text, allGames, lang}: Props) {
  if (!(lang in fuseSingletonObj)) {
    const fuseInstance = new Fuse<SearchGame>(allGames, options)
    fuseSingletonObj[lang] = fuseInstance
  }

  const fuseInstance = fuseSingletonObj[lang]!
  const keyword = text.toLowerCase()
  const result = fuseInstance.search(keyword)
  return result.map((res) => res.item)
}
